/**
 * Design presets for QR codes
 */

export const DESIGN_PRESETS = {
  minimal: {
    id: 'minimal',
    label: 'Minimal',
    config: {
      qrOptions: { type: 'square', color: '#000000' },
      backgroundOptions: { color: '#ffffff' },
      dotsOptions: { type: 'square', color: '#000000' },
      cornersSquareOptions: { type: 'square', color: '#000000' },
      cornersDotOptions: { type: 'square', color: '#000000' },
      margin: 10,
      errorCorrectionLevel: 'M',
    },
  },
  dark: {
    id: 'dark',
    label: 'Dark',
    config: {
      qrOptions: { type: 'square', color: '#e2e8f0' },
      backgroundOptions: { color: '#0f172a' },
      dotsOptions: { type: 'square', color: '#e2e8f0' },
      cornersSquareOptions: { type: 'square', color: '#e2e8f0' },
      cornersDotOptions: { type: 'square', color: '#e2e8f0' },
      margin: 12,
      errorCorrectionLevel: 'M',
    },
  },
  neon: {
    id: 'neon',
    label: 'Neon',
    config: {
      qrOptions: { type: 'rounded', color: '#00ff88' },
      backgroundOptions: { color: '#0a0a0f' },
      dotsOptions: { type: 'rounded', color: '#00ff88' },
      cornersSquareOptions: { type: 'extra-rounded', color: '#00ff88' },
      cornersDotOptions: { type: 'dot', color: '#00ff88' },
      margin: 14,
      errorCorrectionLevel: 'H',
    },
  },
  soft: {
    id: 'soft',
    label: 'Soft',
    config: {
      qrOptions: { type: 'rounded', color: '#64748b' },
      backgroundOptions: { color: '#f8fafc' },
      dotsOptions: { type: 'rounded', color: '#64748b' },
      cornersSquareOptions: { type: 'extra-rounded', color: '#64748b' },
      cornersDotOptions: { type: 'dot', color: '#64748b' },
      margin: 16,
      errorCorrectionLevel: 'M',
    },
  },
  bold: {
    id: 'bold',
    label: 'Bold',
    config: {
      qrOptions: { type: 'square', color: '#dc2626' },
      backgroundOptions: { color: '#fef2f2' },
      dotsOptions: { type: 'square', color: '#dc2626' },
      cornersSquareOptions: { type: 'square', color: '#dc2626' },
      cornersDotOptions: { type: 'square', color: '#dc2626' },
      margin: 8,
      errorCorrectionLevel: 'H',
    },
  },
};
